import PropTypes from 'prop-types'
import React     from 'react'
import { Route } from 'react-router-dom'

import { generalRegistrationSetting } from './settings'
import { login, profile, contactForm, cardNumberForm, basicRegistration, resendActivationEmail, \
         registrationWithBV, registrationWithoutBV, initPasswordReset, confirmPasswordReset }   \
  from './routes'
import { ClientLogin, Profile, ContactForm, CardNumberForm, InitPasswordReset, \
         ConfirmPasswordReset, ResendActivationEmail, LoginCredentialsForm,    \
         LoginCredentialsFormWithBV, LoginCredentialsFormWithoutBV } from './components'

export * from './routes'

route = (path, component, options) ->
  <Route key={path} path={path} component={component} {...options} />

export defaultClientRoute    = (settings) -> profile
export defaultLoggedOutRoute = (settings) -> login

export adminRoutes = ->
  [route(profile, Profile)]

export clientRoutes = ->
  [
    route(contactForm, ContactForm)
    route(profile,     Profile)
  ]

export loggedOutRoutes = (settings) ->
  registrationSetting = generalRegistrationSetting(settings)

  routes = [
    route(login,                 ClientLogin),
    route(initPasswordReset,     InitPasswordReset),
    route(confirmPasswordReset,  ConfirmPasswordReset),
    route(resendActivationEmail, ResendActivationEmail),
    route(contactForm,           ContactForm)
  ]

  routes = routes.concat([
    route(cardNumberForm,        CardNumberForm),
    route(basicRegistration,     LoginCredentialsForm),
    route(registrationWithBV,    LoginCredentialsFormWithBV),
    route(registrationWithoutBV, LoginCredentialsFormWithoutBV)
  ]) if registrationSetting.enabled

  routes
